
<div *ngIf="modaltoopen === 'firstTime'">   
    <div class="modal-body">
        <div id="loader" *ngIf="enableLoader"></div>
        <div *ngIf="!enableLoader" id="fido-container">
            
        </div>
        <!-- <h4 class="text-bold text-center">Passkey login not enabled</h4>
        <p class="text-center text-wrap">
            Your passkey is not enabled. Login with username and password to enable.
        </p>
        <button class="btn btn-block btn-secondary btn-close-change" (click)="close()">Close</button> -->
    </div>
</div>
<div *ngIf="modaltoopen === 'afterOTPSubmit'">   
    <div class="modal-body">
        <div id="loader" *ngIf="enableLoader"></div>
      
        <h4 class="text-bold text-center">{{'home.loginForm.Biometrics.enable' | cxTranslate}}</h4>
        <div *ngIf="!enableLoader">
        <p class="text-center text-wrap">
            {{'home.loginForm.Biometrics.doyouwantEnable' | cxTranslate }}
        </p>
        <p class="text-center">{{'home.loginForm.Biometrics.enableSetting' | cxTranslate }}
        </p>
        
        <button class="btn btn-block btn-primary" (click)="yesAllow()">{{'home.loginForm.Biometrics.yesallow' | cxTranslate}}</button>
        <button class="btn btn-block btn-secondary btn-close-change" (click)="close('cancel')">{{'home.loginForm.Biometrics.notnow' | cxTranslate}}</button>
        </div>
    </div>
</div>
<div *ngIf="modaltoopen === 'disableFingerprint'">
    <div class="modal-body">
        <div id="loader" *ngIf="enableLoader"></div>
        <h4 class="text-bold text-center">{{'home.loginForm.Biometrics.Disablepasskeylogin' | cxTranslate}}</h4>
        <div *ngIf="!enableLoader">
            <p class="text-center text-wrap">
                {{'home.loginForm.Biometrics.confirmMsg' | cxTranslate }}
            </p>
            
            <button class="btn btn-block btn-primary" (click)="removeCredentials()">{{'home.loginForm.Biometrics.yesdisable' | cxTranslate}}</button>
            <button class="btn btn-block btn-secondary btn-close-change" (click)="close('cancel')">{{'home.loginForm.Biometrics.cancel' | cxTranslate}}</button>
        </div>

    </div>
</div>
